import { createMuiTheme } from "@material-ui/core"

export const defaultTheme = createMuiTheme({
    palette: {
        primary: {
            main: "#0075C9"
        },
        secondary: {
            main: "#0C9ED9"
        },
        error: {
            main: "#D62015"
        },
        warning: {
            main: "#A15C00"
        },
        info: {
            main: "#0262B9"
        },
        success: {
            main: "#007E44"
        },
        grey: {
            50: "#F8F9F9",
            100: "#F4F5F6",
            200: "#EDF0F2",
            300: "#DADEE2",
            400: "#D0D4D9",
            500: "#ACB0B5",
            600: "#8E9399",
            700: "#65686C",
            800: "#53565A",
            900: "#3F4145",
            A100: "#D0D4D9"
        }
    },
    typography: {
        fontFamily: "Inter, Helvetica Neue, sans-serif"
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                "&:hover": {
                    backgroundColor: "#0C9ED9"
                },
                "&:active": {
                    backgroundColor: "#083176"
                },
                "&:disabled": {
                    backgroundColor: "#F4F5F6",
                    color: "#65688C"
                }
            }
        },
        MuiInputLabel: {
            root: {
                minWidth: 150
            }
        }
    }
})
